import FitnessDashboard from './Dashboard';
function App() { return <FitnessDashboard />; }
export default App;
